import { render, staticRenderFns } from "./IntvPlace.vue?vue&type=template&id=6290a9a4&"
import script from "./IntvPlace.vue?vue&type=script&lang=js&"
export * from "./IntvPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports